module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedback"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer clearfix"
  }, [_c('div', {
    staticClass: "name-and-phone"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailbox),
      expression: "mailbox"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号或邮箱"
    },
    domProps: {
      "value": (_vm.mailbox)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailbox = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorText),
      expression: "errorText"
    }]
  }, [_vm._v(_vm._s(_vm.errorText))])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "inpText",
    attrs: {
      "type": "text",
      "placeholder": "咨询或建议"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "focus": function($event) {
        _vm.UpdateText(true)
      },
      "blur": function($event) {
        _vm.UpdateText(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "value": "提交"
    },
    on: {
      "click": _vm.feedBack
    }
  })]), _vm._v(" "), _c('Modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedback-content"
  }, [_c('h3', [_vm._v("问题反馈")]), _vm._v(" "), _c('p', [_vm._v("请填写您的意见或建议，以便帮助我们更好的为您提供服务！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-737d18b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/FeedBack.vue
// module id = 772
// module chunks = 1